<template>
  <div class="player-action-buttons-wrapper">
       <slot name="playPauseButton"></slot>
        <button style="display: flex; align-items: center;justify-content:center;" @click="forwardBackwardVideoBy1Sec('backward')" class="btn btn-outline-secondary play common-markinmarkout-action-btn">
          -1S
        </button>
        <button style="display: flex; align-items: center;justify-content:center;" @click="forwardBackwardVideoBy1Sec('forward')" class="btn btn-outline-secondary play common-markinmarkout-action-btn">
          +1S
        </button>
        <button style="display: flex; align-items: center;justify-content:center;" @click="forwardBackwardVideoByFrame('backward')" class="btn btn-outline-secondary play common-markinmarkout-action-btn">
         -1F
        </button>
        <button style="display: flex; align-items: center;justify-content:center;" @click="forwardBackwardVideoByFrame('forward')" class="btn btn-outline-secondary play common-markinmarkout-action-btn">
           +1F
        </button>
  </div>
</template>

<script>
export default {
  name:"buttonsComponent",
  methods:{
     forwardBackwardVideoBy1Sec(type){
        this.$emit("forwardBackwardVideoBy1Sec",type)
     },
     forwardBackwardVideoByFrame(type){
        this.$emit('forwardBackwardVideoByFrame',type);
     }
  }
}
</script>

<style scoped lang="scss">
    .player-action-buttons-wrapper{
         display: flex;
         gap: 5px;
         button{
             font-size: 12px !important;
         }

         .common-play-pause svg{
             width: 25px;
             height: 25px;
         }
    }
</style>